import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { LoadingController } from '@ionic/angular';

import { RedeemReward } from 'src/app/interfaces/reward-interface';
import { SiteContentModel } from 'src/app/models/sitecontent-model';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { ProgressingComponent } from 'src/app/components/progressing/progressing.component';

interface BoydRedeemRewardConfig {
  redeem_reward_header?: string;
  buttonText?: string;
  boyd_redeem_reward?: any;
}

@Component({
  selector: 'app-boyd-redeem-rewards',
  templateUrl: './boyd-redeem-rewards.component.html',
  styleUrls: ['./boyd-redeem-rewards.component.scss'],
})
export class BoydRedeemRewardsComponent implements OnInit, AfterViewInit {

  public bonusOffers: RedeemReward[] = [];
  public selectedOffer: RedeemReward | null;
  public error: any;
  public labels: BoydRedeemRewardConfig;
  buttonAppendText: string;

  @ViewChild(ProgressingComponent) progressingUI!: ProgressingComponent;

  constructor(
    private boydRewardsService: BoydRewardsService,
    private siteContentService: SiteContentService,
    private loadingCtrl: LoadingController,
    public utils: UtilsService,
    public successMessageService: SuccessMessageService
  ) {
    this.successMessageService.clearMessage();
    this.labels = {};
    this.selectedOffer = null;
  }

  ngAfterViewInit() {
    this.siteContentService.loadConfig('boyd_redeem_reward')
      .then((response: BoydRedeemRewardConfig) => {
        this.labels = response;
      });
  }

  ngOnInit() {
    this.boydRewardsService.getRedeemRewards().subscribe(res => {
      if (!!res.result && res.payload) {
        this.bonusOffers = res.payload;
      }
    });
  }

  selectOffer(offer) {
    this.buttonAppendText = 'for ' + offer.requiredPoints + (offer.requiredPoints > 1 ? ' POINTS' : ' POINT');
    this.selectedOffer = offer;
  }

  onRedeemReward() {
    this.successMessageService.clearMessage();

    const obj = {
      id: this.selectedOffer.id,
      conversion: this.selectedOffer.amount,
    };

    const apiCall$ = this.boydRewardsService.callRedeemRewards(obj);
    this.progressingUI.listenObservable(apiCall$);
    apiCall$.subscribe(
      res => {
        /**
         * the payload is the remaining balance
         * it is a number and could be 0 or 1 - causing the condition to behave unexectedly
         */
        if (res.result) {
          this.error = null;

          this.successMessageService.setMessage(
            'Congrats, you have redeemed ' +
            this.selectedOffer.requiredPoints +
            (this.selectedOffer.requiredPoints > 1 ? ' points' : ' point') +
            ' for' + ' $' + this.selectedOffer.amount + ' bonus.'
          );
          this.selectedOffer = null;
        }
      },
      err => {
        this.error = err;
        this.selectedOffer = null;
        this.successMessageService.clearMessage();
        switch (err.getErrorCode().toUpperCase()) {
          case 'INSUFFICIENT_POINTS':
            err.setErrorMessage('Sorry! You don\'t have enough points.');
            break;
          case 'CONNECTION_ERROR':
            err.setErrorMessage('Sorry! There was a connection error.');
            break;
          default:
            err.setErrorMessage('Oops! We cannot confirm your account information.');
            break;
        }
      }
    );
  }
}
